import React from 'react';
export function useDefaultTimeZone(date) {
    const defaultTimeZone = date ? date.timeZone() : 'default';
    const [lastValue, setLastValue] = React.useState(defaultTimeZone);
    if (date && defaultTimeZone !== lastValue) {
        setLastValue(defaultTimeZone);
    }
    const timeZone = date ? defaultTimeZone : lastValue;
    return timeZone;
}
